// extracted by mini-css-extract-plugin
export default {"dropzone":"styles_dropzone__z7Gzf","text":"styles_text__goGS1","wrapper":"styles_wrapper__ePZiu","noClick":"styles_noClick__Pth2r","innerHolder":"styles_innerHolder__euQrO"};